class InlineVideoControl {
	element: HTMLElement;
	videoId: string;
	video: HTMLElement;
	iframe: HTMLIFrameElement;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	player: any;

	constructor(element: HTMLElement) {
		this.element = element;
		this.videoId = element.getAttribute('data-video-id') as string;
		this.video = document.getElementById(this.videoId) as HTMLElement;
		this.iframe = this.video?.querySelector('iframe') as HTMLIFrameElement;
	}

	init() {
		if (!this.iframe || !window.Vimeo?.Player) {
			return;
		}

		this.player = new window.Vimeo.Player(this.iframe);
		this.element.addEventListener('click', () => this.togglePlay());
	}

	togglePlay(): void {
		if (!this.player) return;

		const paused = this.element.getAttribute('data-paused') === 'true';
		if (paused) {
			this.element.setAttribute('data-paused', 'false');
			this.element.setAttribute('aria-label', 'Pause video');
			this.element.setAttribute('aria-pressed', 'false');
			this.player.play();
		} else {
			this.element.setAttribute('data-paused', 'true');
			this.element.setAttribute('aria-label', 'Play video');
			this.element.setAttribute('aria-pressed', 'true');
			this.player.pause();
		}
	}
}

function initInlineVideoControls() {
	document.querySelectorAll('.inline-video-control').forEach((element) => {
		if ((element as HTMLElement).dataset.initialized) {
			return;
		}
		const inlineVideoControl = new InlineVideoControl(element as HTMLElement);
		inlineVideoControl.init();
		if (inlineVideoControl.player) {
			(element as HTMLElement).dataset.initialized = 'true';
		}
	});
}

window.addEventListener('load', initInlineVideoControls);
window.addEventListener('rocket-allScriptsLoaded', initInlineVideoControls);
